var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitheart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -988.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.54739 0 0 .74308 -63.84 876.9)",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.1054 0 0 1.0796 -12.014 -18.867)",
    d: "m147.21 156.42c-2.5357.0128-5.3218.48209-8.4062 1.5312-33.623 19.537 11.705 51.041 30.844 78.094l.55251.13831c21.033-29.569 61.072-62.108 30.479-78.232-24.237-8.244-30.711 19.198-30.938 20.188-.19739-.86352-5.1424-21.806-22.531-21.719z",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitheart);
export default __webpack_public_path__ + "static/media/suitheart.c58f949c87a5a6cc48e192d389490ac0.svg";
export { ForwardRef as ReactComponent };